import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ArrowIcon from "@material-ui/icons/ArrowForward";
import UserIcon from "@material-ui/icons/PersonOutline";
import HeartIcon from "@material-ui/icons/FavoriteBorderSharp";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import { WidgetProps } from "../widgets";
import ImageEnlarge from "../ui/Media/ImageEnlarge";
import { IImage } from "../../models/Image";
import { FileType } from "../../laco-common/base/models/IFile";
import homeImage1 from "../../assets/tempImages/mentalHealth1.jpeg";
import homeImage2 from "../../assets/tempImages/mentalHealth2.jpeg";
import homeImage3 from "../../assets/tempImages/mentalHealth3.jpeg";
import homeImage4 from "../../assets/tempImages/mentalHealth4.jpeg";
import homeImageBlue from "../../assets/tempImages/homeImageBlue.jpeg";
import DescriptionText from "../../laco-common/components/DescriptionText";
import ImageView from "../ui/Media/ImageView";
import "./HomeBlue.scss";

type MentalHealthResourcesWidgetProps = {} & WidgetProps;

const services: { title: string; desc: string; icon: any; imageUrl: string; url: string; linkText: string }[] = [
	{
		title: "Peer Support",
		desc: "A trained peer will be give you a call for support immediately.",
		icon: <UserIcon color="primary" />,
		imageUrl: homeImage1,
		url: "/peer-support",
		linkText: "Contact Peer Support",
	},
	{
		title: "Facilities & Clinicians",
		desc: "Be guided or privately search for a vetted clinician in your area to access assistance .",
		icon: <HeartIcon color="primary" />,
		imageUrl: homeImage2,
		url: "/ps/facilities",
		linkText: "Search",
	},
	{
		title: "24/7 Firefighter & Family Support Line",
		desc: "(844) 525-3473",
		icon: <EmailOutlinedIcon color="primary" />,
		imageUrl: homeImage3,
		url: "",
		linkText: "",
	},
	{
		title: "24/7 Suicide Crisis Hotline",
		desc: "1 (800) 273-8255",
		icon: <AssignmentOutlinedIcon color="primary" />,
		imageUrl: homeImage4,
		url: "",
		linkText: "",
	},
];

export const MentalHealthResourcesWidget: React.FC<MentalHealthResourcesWidgetProps> = (
	props: MentalHealthResourcesWidgetProps
) => {
	// const [Component, setComponent] = useState<any>(null);

	useEffect(() => {}, []);

	const media: IImage = {
		filename: "",
		fileType: FileType.IMAGE,
		url: homeImageBlue,
	}; //getSiteMedia();

	return (
		<div className="container section-padding">
			<div className="mt-0 mb-5">
				<h3 className="">Mental Health Resources</h3>
				<p className="">
					The B&W is here for you. We have collected free and confidential resources that can help you or the
					ones you care about find the support they need. Some resources include connecting with other
					firefighters, a list of facilities and clinicians, and so much more.
					<NavLink to={"/peer-support"} className="d-inline-block pl-2">
						<OrangeArrowLink text={"Learn more"} url={"/peer-support"} />
					</NavLink>
				</p>
			</div>
			<div className="cards-container">
				{services.map(({ title, desc, imageUrl, icon, url, linkText }, i) => (
					<NavLink to={url} key={i} className="scale-in-image-view d-inline-block">
						<div className="card bg-light" key={i}>
							<ImageView
								className="card-img-top"
								image={{ ...media, url: imageUrl }}
								imageWidth100Pct
								viewHeight={180}
								renderContainer
							/>
							<div className="card-body">
								<span className="card-icon">{icon}</span>
								<h4 className="card-title">{title}</h4>
								<p className="card-text" style={{ fontSize: "15px" }}>
									<DescriptionText text={desc} />
								</p>
								<OrangeArrowLink text={linkText} url={url} />
							</div>
						</div>
					</NavLink>
				))}
			</div>
		</div>
	);
};

type OrangeArrowLinkProps = {
	url: string;
	text?: string;
};

const OrangeArrowLink: React.FC<OrangeArrowLinkProps> = ({ url, text }) => {
	if (!url) return null;
	return (
		<span
			className="text-primary arrow-link text-uppercase w-100 d-inline-flex align-items-center py-1 pr-1 font-weight-bold"
			// to={url}
			style={{ fontSize: "13px" }}
		>
			<span>{text || url}</span>
			<ArrowIcon style={{ fontSize: "16px", marginLeft: "3px" }} />
		</span>
	);
};
